import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutCallinScriptTemplateLookup extends Layout {
}
